<template>
  <div>
    <ModalBoleto
      v-model="abreModal"
      :titulo="'Boleto Projeto - ' + sqProjetoVar"
      :src="urlPagamento"
    />
    <ModalQrCode
      :valor="vlAstec"
      v-model="mostraQRCode"
      :qrCodeImage="qrCodeImage"
      :textAreaData="textAreaData"
      :dadosPixDoProjeto="dadosPixDoProjeto"
      :titulo="'QR Code Pix Projeto - ' + sqProjetoVar"
    />

    <PageHeader :title="titleHeader" />
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div class="card" v-if="!loading">
      <div class="card-body">
        <div class="row d-flex justify-content-between">
          <div class="col-md-8">
            <b-card-title>
              <h5 class="card-title mb-3">
                Informações do Projeto -
                <span
                  v-if="!importacao"
                  class="badge badge-pill font-size-15"
                  :class="{
                    'badge-soft-info': statusProjeto === 'ELABORADO',
                    'badge-soft-success': statusProjeto === 'LIBERADO',
                    'badge-soft-dark': statusProjeto === 'LIQUIDADO',
                    'badge-soft-danger': statusProjeto === 'EXCLUIDO',
                    'badge-soft-warning': statusProjeto === 'BAIXA PARCIAL'
                  }"
                >
                  {{ statusProjeto }}
                </span>

                <span
                  v-else
                  class="badge badge-pill font-size-12"
                  :class="{
                    'badge-soft-info': statusProjeto === 'COMPLETO',
                    'badge-soft-success': statusProjeto === 'EXPORTADO',
                    'badge-soft-danger': statusProjeto === 'INCOMPLETO'
                  }"
                >
                  {{ statusProjeto }}
                </span>
                <span v-if="sqProjetoVar"> - {{ sqProjetoVar }}</span>
              </h5>
            </b-card-title>
          </div>
          <div
            class="col-md-4 d-flex justify-content-end mb-3"
            v-if="permiteDuplicar && !importacao"
          >
            <b-button variant="primary" @click="duplicarProjeto()">
              <i class="bx bx-copy"></i>
              Duplicar Informações
            </b-button>
          </div>
        </div>

        <div class="row d-flex mb-3">
          <div class="col-md-3">
            <b-form-group label="Cooperado" :state="state('selecaoCooperado')">
              <multiselect
                v-model="selecaoCooperado"
                :options="cooperadoLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                :allowEmpty="false"
                :taggable="false"
                select-label=""
                @input="carregarClienteRural"
                invalid-feedback="Campo obrigatório"
                :disabled="disabledCampos || importacao || emEdicao"
              >
                <span slot="noOptions">Nenhum Cooperado disponível</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Cliente Rural"
              :state="state('selecaoClienteRural')"
            >
              <multiselect
                v-model="selecaoClienteRural"
                :options="clienteRuralLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                invalid-feedback="Campo obrigatório"
                :disabled="disabledCampos || importacao"
                :loading="loadingClienteRural"
              >
                <span slot="noOptions">Nenhum Cliente Rural disponível</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group
              label="CPF/CNPJ"
              :state="state('selecaoClienteRural')"
            >
              <multiselect
                label="cpfCnpj"
                invalid-feedback="Campo obrigatório"
                :disabled="disabledCampos || importacao"
                v-model="selecaoClienteRural"
                :options="filteredOptions"
                :custom-label="formatCpfCnpj"
                track-by="cpfCnpj"
                placeholder="Selecione"
                select-label=""
                :loading="loadingClienteRural"
                :max-height="200"
                :internal-search="false"
                @search-change="updateSearch"
              >
                <span slot="noOptions">Nenhum CPF/CNPJ disponível</span>
              </multiselect>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group
              label="N° Projeto"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model="numeroProjeto"
                v-mask="'########'"
                type="text"
                :maxlength="8"
                :state="state('numeroProjeto')"
                :disabled="disabledCampos || importacao"
              />
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group
              label="Data do Projeto"
              :state="state('dataProjeto')"
              invalid-feedback="Campo obrigatório"
            >
              <date-picker
                append-to-body
                format="DD/MM/YYYY"
                v-model="dataProjeto"
                value-type="YYYY-MM-DD HH:mm:ss"
                @input="disableDatasPosteriores()"
                :disabled-date="disableDatasFuturas"
                :disabled="disabledCampos || importacao"
                :class="{ 'opacity-date': disabledCampos || importacao }"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row d-flex mb-3">
          <div class="col-md-3">
            <b-form-group
              label="Instituição Financeira"
              :state="state('selecaoInstituicaoFinanceira')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoInstituicaoFinanceira"
                :loading="loadingInstFinanceira"
                :disabled="disabledCampos || importacao"
                :options="instituicaoFinanceiraLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                @input="carregarAgencia"
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Agência"
              :state="state('selecaoAgencia')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoAgencia"
                :loading="loadingAgencia"
                :disabled="disabledCampos"
                :options="instituicaoAgenciaLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Município - UF"
              :state="state('selecaoMunicipio')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoMunicipio"
                :disabled="disabledCampos"
                :options="selecaoMunicipioLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
              />
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="Linha de Crédito"
              :state="state('selecaoLinhaCredito')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoLinhaCredito"
                :options="linhaCreditoLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                :disabled="disabledCampos || importacao"
              >
                <span slot="noOptions"
                  >Nenhuma Linha de Crédito disponível</span
                >
              </multiselect>
            </b-form-group>
          </div>
        </div>
        <div class="row d-flex mb-3">
          <div class="col-md-3">
            <b-form-group
              label="Safra"
              :state="state('selecaoSafra')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoSafra"
                :disabled="disabledCampos || importacao"
                :options="selecaoSafraLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                @input="carregarItemAgropecuario"
              />
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="Tipo de Projeto"
              :state="state('selecaoTipoProjeto')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoTipoProjeto"
                :options="tipoProjetoLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                @input="carregarItemAgropecuario"
                :disabled="disabledCampos"
              >
                <span slot="noOptions">Nenhum Tipo de Projeto disponível</span>
              </multiselect>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="Item Agropecuário"
              :state="state('selecaoItemAgropecuario')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoItemAgropecuario"
                :disabled="disabledCampos"
                :options="itemAgropecuarioLkp"
                :loading="loadingItemAgropecuario"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
              >
                <span slot="noOptions"
                  >Lista vazia, selecione a safra e tipo de projeto.</span
                >
              </multiselect>
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="Área (ha)"
              invalid-feedback="Campo obrigatório"
              :state="state('areaHa')"
            >
              <money
                v-model="areaHa"
                v-bind="area"
                class="form-control"
                :state="state('areaHa')"
                :disabled="disabledCampos || importacao"
              >
              </money>
            </b-form-group>
          </div>
        </div>
        <div class="row d-flex mb-3">
          <div class="col-md-3">
            <b-form-group
              label="Modalidade do Seguro"
              :state="state('selecaoModalidadeSeguro')"
              invalid-feedback="Campo obrigatório"
            >
              <multiselect
                v-model="selecaoModalidadeSeguro"
                :disabled="disabledCampos || importacao"
                :options="selecaoModalidadeSeguroLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Valor Orçado"
              :state="state('vlOrcado')"
              invalid-feedback="Campo obrigatório"
            >
              <money
                v-model="vlOrcado"
                v-bind="money"
                class="form-control"
                :state="state('vlOrcado')"
                :disabled="disabledCampos || importacao"
              >
              </money>
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="% Astec"
              :state="state('perAstec')"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model.lazy="perAstec"
                v-money="porcentagem"
                :maxlength="8"
                :state="state('perAstec')"
                :disabled="disabledCampos || importacao"
              />
            </b-form-group>
          </div>
          <div class="col-md-3">
            <b-form-group
              label="Valor Astec"
              :state="state('vlAstec')"
              invalid-feedback="Campo obrigatório"
            >
              <money
                v-model="vlAstec"
                v-bind="money"
                class="form-control money-mask"
                @blur="onVlAstecChange"
                :disabled="disabledCampos || importacao"
              >
              </money>
            </b-form-group>
          </div>
        </div>

        <div v-if="!importacao" class="row d-flex mb-3">
          <div class="col-md-3">
            <b-form-group label="Projeto Unicampo">
              <multiselect
                v-model="selecaoProjeto"
                :options="selecaoProjetoLkp"
                label="name"
                track-by="name"
                placeholder="Selecione"
                select-label=""
                :disabled="true"
                :max-height="150"
              />
            </b-form-group>
          </div>

          <div class="col-md-3">
            <b-form-group
              label="N° Operação"
              invalid-feedback="Campo obrigatório"
            >
              <b-form-input
                v-model="nOperacao"
                v-mask="'##################'"
                :maxlength="30"
                type="text"
                :disabled="disabledCampos"
              />
            </b-form-group>
          </div>

          <div class="col-md-2">
            <b-form-group
              label="Data Vencimento"
              invalid-feedback="Campo obrigatório"
            >
              <date-picker
                v-model="dataVencBoleto"
                value-type="YYYY-MM-DD HH:mm:ss"
                format="DD/MM/YYYY"
                append-to-body
                :disabled="disabledCampos"
                :disabled-date="disableDatasAnteriores"
              />
            </b-form-group>
          </div>

          <div class="col-md-2">
            <b-form-group
              label="Valor Liberado"
              invalid-feedback="Campo obrigatório"
            >
              <money
                v-model="vlLiberado"
                v-bind="money"
                class="form-control"
                :disabled="true"
              >
              </money>
            </b-form-group>
          </div>

          <div class="col-md-2">
            <b-form-group
              label="Data Crédito"
              invalid-feedback="Campo obrigatório"
            >
              <date-picker
                v-model="dataCredito"
                value-type="YYYY-MM-DD HH:mm:ss"
                format="DD/MM/YYYY"
                append-to-body
                :disabled="true"
              />
            </b-form-group>
          </div>
        </div>

        <div class="row d-flex justify-content-between mb-1 align-items-center">
          <div class="col-md-6">
            <div v-if="!importacao" class="d-flex gap-2">
              <b-button
                :disabled="
                  !sqProjetoVar > 0 ||
                    loadingBoleto ||
                    loadingGeral ||
                    !permiteDuplicar ||
                    disabledCampos
                "
                size="md"
                variant="light"
                @click="gerarBoleto"
                class="mb-2 mb-md-0"
                data-tooltip="Gerar Boleto"
                data-tooltip-location="bottom"
                style="width: 45px; height: 37px"
              >
                <i v-if="!loadingBoleto" class="mdi mdi-barcode"></i>
                <b-spinner
                  class="m-0"
                  small
                  variant="success"
                  v-if="loadingBoleto"
                ></b-spinner>
              </b-button>

              <b-button
                :disabled="
                  !sqProjetoVar > 0 ||
                    loadingPix ||
                    loadingGeral ||
                    !permiteDuplicar ||
                    disabledCampos
                "
                size="md"
                variant="light"
                @click="gerarPix"
                class="mb-2 mb-md-0"
                data-tooltip="Gerar Pix"
                data-tooltip-location="bottom"
                style="width: 45px; height: 37px"
              >
                <img
                  height="18"
                  alt="Pix Brands"
                  v-if="!loadingPix"
                  :src="require('@/assets/images/pix-brands-solid.svg')"
                />
                <b-spinner
                  class="m-0"
                  small
                  variant="success"
                  v-if="loadingPix"
                ></b-spinner>
              </b-button>
              <b-button
                v-show="statusTipoProjeto(statusProjeto)"
                :disabled="!sqProjetoVar > 0 || loadingSalvar"
                size="md"
                variant="light"
                data-tooltip="Movimentações"
                data-tooltip-location="bottom"
                @click="openModalMovimentacao"
              >
                <div v-if="!loadingMovimentacao">
                  <i class="fa fa-solid fa-wallet"></i>
                </div>
                <b-spinner
                  small
                  class="mt-0"
                  variant="success"
                  v-if="loadingMovimentacao"
                ></b-spinner>
              </b-button>
            </div>
          </div>

          <div
            class="col-md-6 d-flex justify-content-end align-items-center gap-2"
          >
            <b-button
              size="md"
              @click="voltar"
              variant="secondary"
              class="mb-2 mb-md-0"
              data-tooltip="Voltar"
              :disabled="loadingGeral"
              data-tooltip-location="bottom"
            >
              <i class="me-2 mdi mdi-arrow-left-circle"></i>
              Voltar
            </b-button>
            <b-button
              size="md"
              variant="success"
              data-tooltip="Salvar e Voltar"
              data-tooltip-location="bottom"
              @click="insertProjeto('voltar')"
              style="width: 142px; height: 37px"
              :disabled="loadingGeral || disabledCampos"
              class="mb-2 mb-md-0 d-flex align-items-center justify-content-center"
            >
              <div v-if="!loadingSalvarVoltar">
                <i class="me-2 mdi mdi-content-save"></i>
                <span>Salvar e Voltar</span>
              </div>
              <b-spinner
                small
                variant="white"
                v-if="loadingSalvarVoltar"
              ></b-spinner>
            </b-button>

            <b-button
              v-if="!importacao && !editandoProjeto"
              size="md"
              variant="success"
              data-tooltip-location="bottom"
              data-tooltip="Salvar e Continuar"
              @click="insertProjeto('continuar')"
              style="width: 175px; height: 37px"
              class="mb-2 mb-md-0 d-flex align-items-center justify-content-center"
              :disabled="
                loadingSalvarContinuar || disabledCampos || editandoProjeto
              "
            >
              <span v-if="!loadingSalvarContinuar">
                <i class="me-2 mdi mdi-content-save"></i>
                Salvar e Continuar
              </span>
              <b-spinner
                small
                variant="white"
                v-if="loadingSalvarContinuar"
              ></b-spinner>
            </b-button>

            <b-button
              size="md"
              variant="success"
              data-tooltip="Salvar"
              data-tooltip-location="bottom"
              @click="insertProjeto('salvar')"
              style="width: 85px; height: 37px"
              v-else-if="!importacao && editandoProjeto"
              :disabled="loadingGeral || disabledCampos"
              class="d-flex align-items-center justify-content-center"
            >
              <div v-if="!loadingSalvarNormal">
                <i class="me-1 mdi mdi-content-save"></i>
                <span>Salvar</span>
              </div>
              <b-spinner
                small
                variant="white"
                v-if="loadingSalvarNormal"
              ></b-spinner>
            </b-button>

            <b-button
              v-else
              variant="info"
              size="md"
              @click="insertProjeto('exportar')"
              :disabled="loadingSalvarExportar || disabledCampos"
              data-tooltip="Salvar e Exportar"
              data-tooltip-location="bottom"
            >
              <span v-if="!loadingSalvarExportar">
                <i class="mdi mdi-content-save"></i>
                Salvar e Exportar
              </span>

              <b-spinner
                variant="primary"
                small
                class="ms-2"
                v-if="loadingSalvarExportar"
              ></b-spinner>
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <formDadosImportados v-if="importacao && !loading" />
    <ModalMovimentacao
      :isOpenModal.sync="showModalMovimentacao"
      :dadosMovimentacao="retornoMovimentacao"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { Money } from "v-money";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import ModalQrCode from "@/components/astec/modalQrCode";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";
import { MovimentacaoService } from "@/services/astec/movimentacao";
import { required, requiredIf, minValue } from "vuelidate/lib/validators";
import ModalBoleto from "@/components/assinaturaEletronica/modalAssinatura";
import { mapearDadosFormularioProjeto } from "@/utils/astec/projetoPixMapearCampos";
import ModalMovimentacao from "@/components/astec/projetos/movimentacao/modalMovimentacao";
import formDadosImportados from "@/components/astec/projetos/lotesImportacao/formDadosImportados";

export default {
  mixins: [clienteRuralMixin],
  components: {
    Money,
    PageHeader,
    ModalBoleto,
    Multiselect,
    ModalQrCode,
    ModalMovimentacao,
    formDadosImportados
  },
  data() {
    return {
      statusProjeto: "",
      selecaoCooperado: null,
      cooperadoLkp: [],
      clienteRuralLkp: [],
      selecaoClienteRural: null,
      selecaocpfCnpj: "",
      cpfCnpjInvalido: false,
      numeroProjeto: "",
      dataProjeto: null,
      linhaCreditoLkp: [],
      selecaoLinhaCredito: null,
      selecaoTipoProjeto: null,
      tipoProjetoLkp: [],
      selecaoModalidadeSeguro: null,
      selecaoModalidadeSeguroLkp: [],
      StatusLkp: [],
      selecaoStatus: null,
      itemAgropecuarioLkp: [],
      selecaoItemAgropecuario: null,
      selecaoMunicipio: null,
      selecaoMunicipioLkp: [],
      selecaoSafra: null,
      selecaoSafraLkp: [],
      selecaoProjeto: null,
      selecaoProjetoLkp: [],
      areaHa: "",
      nOperacao: "",
      vlOrcado: "",
      perAstec: "",
      vlAstec: "",
      vlLiberado: "",
      dataCredito: null,
      instituicaoFinanceiraLkp: [],
      selecaoInstituicaoFinanceira: null,
      loadingInstFinanceira: false,
      loadingClienteRural: false,
      loadingAgencia: false,
      loadingItemAgropecuario: false,
      instituicaoAgenciaLkp: [],
      selecaoAgencia: null,
      dataVencBoleto: null,
      cdPessoa: "",
      sqUsuario: "",
      cdProjeto: 30,
      sqProjetoVar: null,
      loading: true,
      loadingSalvar: false,
      loadingBoleto: false,
      loadingPix: false,
      submit: false,
      disabledCampos: false,
      titleHeader: "",
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "R$ ",
        masked: false,
        allowBlank: false,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      },
      area: {
        decimal: ",",
        thousands: ".",
        suffix: " (ha)",
        precision: 2,
        masked: false
      },
      porcentagem: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: true
      },
      searchQuery: "",
      dadosAoCarregar: null,
      editandoProjeto: false,
      importacao: false,
      permiteDuplicar: false,
      abreModal: false,
      urlPagamento: "",
      mostraQRCode: false,
      qrCodeImage: "",
      textAreaData: "",

      loadingGeral: false,
      loadingSalvarNormal: false,
      loadingSalvarVoltar: false,
      loadingMovimentacao: false,
      loadingSalvarExportar: false,
      loadingSalvarContinuar: false,

      retornoMovimentacao: null,
      showModalMovimentacao: false,
      suprimirCalculos: false,
      timeoutCalculo: null,
      cdCooperadoSelecionado: null,
      dadosPixDoProjeto: null
    };
  },
  async created() {
    this.importacao = localStorage.getItem("exibirCamposImportacao") === "true";

    await this.buscarDados();

    if (this.$store.state.projetoAstec) {
      const projeto = this.$store.state.projetoAstec;

      this.titleHeader = "Editando Projeto Astec";
      this.cdProjeto = projeto.CD_PROJETO;
      this.sqProjetoVar = projeto.SQ_PROJETO_VAR;
      this.editandoProjeto = true;

      if (this.importacao) {
        this.statusProjeto = projeto.ST_IMPORTACAO;
      } else {
        this.statusProjeto = projeto.ST_PROJETO;
      }

      if (
        projeto.ST_PROJETO !== "ELABORADO" &&
        projeto.ST_IMPORTACAO !== "INCOMPLETO" &&
        projeto.ST_IMPORTACAO !== "COMPLETO"
      ) {
        this.titleHeader = "Consultando Projeto Astec";
        this.disabledCampos = true;
      }

      if (
        (this.cdProjeto == 30 && projeto.CD_PESSOA_CORRETORA == 0) ||
        projeto.CD_PESSOA_CORRETORA == null
      ) {
        this.permiteDuplicar = true;
      } else {
        this.permiteDuplicar = false;
      }

      await this.preencherCampos(projeto);
    } else {
      this.titleHeader = "Criando Projeto Astec";
      this.statusProjeto = "ELABORADO";
    }

    this.selecaoProjeto = this.selecaoProjetoLkp.find(
      el => el.value == this.cdProjeto
    );

    this.$tools.fecharMenu();

    this.dadosAoCarregar = this.montarObjeto();

    if (this.importacao && this.statusProjeto === "INCOMPLETO") {
      this.submit = true;
      this.$nextTick(() => {
        if (this.$v && this.$v.$touch) this.$v.$touch();
      });
    }
  },
  computed: {
    filteredOptions() {
      if (!this.searchQuery) return this.clienteRuralLkp;
      const normalizedSearch = this.normalizeCpfCnpj(this.searchQuery);

      return this.clienteRuralLkp.filter(option => {
        const normalizedOption = this.normalizeCpfCnpj(option.cpfCnpj);
        return normalizedOption.includes(normalizedSearch);
      });
    },
    emEdicao() {
      return !!this.$store.state.projetoAstec;
    }
  },
  validations: {
    selecaoCooperado: { required },
    selecaoClienteRural: { required },
    numeroProjeto: { required },
    dataProjeto: { required },
    selecaoLinhaCredito: { required },
    selecaoModalidadeSeguro: { required },
    selecaoMunicipio: { required },
    selecaoSafra: { required },
    areaHa: { required, minValue: minValue(0.01) },
    vlOrcado: { required, minValue: minValue(1) },
    perAstec: { required },
    vlAstec: { required },
    selecaoInstituicaoFinanceira: { required },

    // ALTERADO: obrigatoriedade quando o modo importação for INCOMPLETO
    selecaoTipoProjeto: {
      required: requiredIf(function() {
        return (
          (this.importacao && this.statusProjeto === "INCOMPLETO") || required
        );
      })
    },

    selecaoItemAgropecuario: {
      required: requiredIf(function() {
        return (
          (this.importacao && this.statusProjeto === "INCOMPLETO") || required
        );
      })
    },

    selecaoAgencia: {
      required: requiredIf(function() {
        return (
          (this.importacao && this.statusProjeto === "INCOMPLETO") || required
        );
      })
    }
  },

  watch: {
    vlOrcado: {
      handler(newVal) {
        if (!this.suprimirCalculos) {
          this.calcularVlAstecDebounced();
        }
        if (newVal === 0) {
          this.vlAstec = 0;
        }
      }
    },

    perAstec: {
      handler(newVal) {
        if (!this.suprimirCalculos) {
          this.calcularVlAstecDebounced();
        }

        if (typeof newVal === "string" && !newVal.includes("%")) {
          const num = parseFloat(newVal.replace(",", "."));
          if (!isNaN(num)) {
            setTimeout(() => {
              this.perAstec = num.toFixed(2).replace(".", ",") + " %";
            }, 10);
          }
          return;
        }
      },
      immediate: true,
      deep: true
    },

    vlAstec: {
      handler(newVal, oldVal) {
        if (this.suprimirCalculos || this.disabledCampos) {
          return;
        }
        if (newVal !== oldVal && newVal !== null && newVal !== undefined) {
          this.recalcularVlOrcadoPorAstec();
        }
        if (newVal === 0) {
          this.vlOrcado = 0;
        }
      }
    }
  },

  methods: {
    calcularVlAstecDebounced() {
      if (this.timeoutCalculo) {
        clearTimeout(this.timeoutCalculo);
      }
      this.timeoutCalculo = setTimeout(() => {
        this.calcularVlAstec();
      }, 300);
    },

    calcularVlOrcadoDebounced() {
      if (this.timeoutCalculo) {
        clearTimeout(this.timeoutCalculo);
      }
      this.timeoutCalculo = setTimeout(() => {
        this.calcularVlOrcado();
      }, 300);
    },

    async buscarDados() {
      await this.getNomeRazaoUsuario();
      await this.buscarLkpCooperado();
      await this.verificarCooperado();
      await this.buscarLkpLinhaCredito();
      await this.buscarLkpTipoProjeto();
      await this.buscarLkpModalidadeSeguro();
      await this.buscarMunicipioUf();
      await this.buscarLkpSafra();
      await this.buscarLkpProjeto();
      await this.carregarClienteRural();

      this.loading = false;
    },

    state(param) {
      if (this.submit) {
        return !this.$v[param].$invalid;
      } else {
        return null;
      }
    },

    disableDatasFuturas(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },

    disableDatasPosteriores(date) {
      if (this.dataProjeto) {
        const today = new Date(this.dataProjeto);
        today.setHours(0, 0, 0, 0);
        return date < today;
      }

      return date;
    },

    disableDatasAnteriores(date) {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      return date < hoje;
    },

    formatarValorParaInput(valor) {
      if (valor === null || valor === undefined || valor === "") {
        return null;
      }

      if (typeof valor === "number") {
        return valor;
      }

      if (typeof valor === "string") {
        const limpo = valor.replace(/[^\d,.-]/g, "");

        if (limpo === "") {
          return null;
        }

        let numero;

        if (limpo.includes(",")) {
          const semMilhar = limpo.replace(/\./g, "");
          numero = parseFloat(semMilhar.replace(",", "."));
        } else {
          numero = parseFloat(limpo);
        }

        return isNaN(numero) ? null : numero;
      }

      return null;
    },

    async preencherCampos(projeto) {
      if (projeto) {
        this.suprimirCalculos = true;

        try {
          if (projeto.PER_ASTEC) {
            this.perAstec = projeto.PER_ASTEC;
          }

          this.selecaoCooperado = this.cooperadoLkp.find(
            el => el.value == projeto.CD_COOPERADO
          );

          await this.carregarClienteRural();

          this.selecaoClienteRural = this.clienteRuralLkp.find(
            el => el.value == projeto.SQ_CLIENTE
          );

          this.numeroProjeto = projeto.NR_PROJETO;
          this.dataProjeto = projeto.DT_PROJETO;

          this.selecaoLinhaCredito = this.linhaCreditoLkp.find(
            el => el.value == projeto.CD_LINHA_CREDITO
          );

          this.selecaoTipoProjeto = this.tipoProjetoLkp.find(
            el => el.name.split(" [")[0] === projeto.DS_TP_PROJETO
          );

          this.selecaoSafra = this.selecaoSafraLkp.find(
            el => el.name == projeto.CD_SAFRA
          );

          await this.carregarItemAgropecuario();

          this.selecaoItemAgropecuario = this.itemAgropecuarioLkp.find(
            el => el.name.split(" [")[0] == projeto.DS_ITEM_AGROPECUARIO
          );

          this.selecaoModalidadeSeguro = this.selecaoModalidadeSeguroLkp.find(
            el => el.value == projeto.CD_MODALIDADE_SEGURO
          );

          this.selecaoMunicipio = this.selecaoMunicipioLkp.find(
            el => el.value == projeto.SQ_REGIAO_PROJETO
          );

          this.areaHa = this.formatarValorParaInput(projeto.QT_AREA);
          this.nOperacao = projeto.CD_OPERACAO_CRED;
          this.vlOrcado = this.formatarValorParaInput(projeto.VL_ORCADO);
          this.vlAstec = this.formatarValorParaInput(projeto.VL_ASTEC);
          this.vlLiberado = this.formatarValorParaInput(projeto.VL_LIBERADO);
          this.dataCredito = projeto.DT_CREDITO_BCO;

          this.selecaoInstituicaoFinanceira = this.instituicaoFinanceiraLkp.find(
            el => el.value == projeto.CD_INSTITUICAO_FINANCEIRA
          );

          await this.carregarAgencia();

          this.selecaoAgencia = this.instituicaoAgenciaLkp.find(
            el => el.value == projeto.NR_AGENCIA
          );

          this.dataVencBoleto = projeto.DT_VENC_BOLETO;
        } finally {
          setTimeout(() => {
            this.suprimirCalculos = false;
          }, 500);
        }
      } else {
        this.$tools.alerta(
          "Ocorreu um erro ao preencher os campos, por favor tente novamente.",
          "error"
        );
      }
    },

    // Método para recalcular vlOrcado quando vlAstec é editado
    recalcularVlOrcadoPorAstec() {
      if (this.suprimirCalculos || !this.vlAstec || !this.perAstec) {
        return;
      }
      clearTimeout(this.recalculoTimeout);
      this.recalculoTimeout = setTimeout(() => {
        this.executarRecalculoVlOrcado();
      }, 300);
    },

    executarRecalculoVlOrcado() {
      if (this.suprimirCalculos || !this.vlAstec || !this.perAstec) {
        return;
      }

      let perAstecStr = this.perAstec.toString();
      if (perAstecStr.includes("%")) {
        perAstecStr = perAstecStr.replace(" %", "").trim();
      }

      let percentual = parseFloat(perAstecStr.replace(",", "."));

      if (isNaN(percentual) || percentual === 0) {
        console.log("Percentual inválido:", this.perAstec);
        return;
      }

      if (percentual > 100.0) {
        this.perAstec = "100,00 %";
        percentual = 100.0;
      }

      const novoVlOrcado = this.vlAstec / (percentual / 100);
      const vlOrcadoArredondado = parseFloat(novoVlOrcado.toFixed(2));

      this.suprimirCalculos = true;
      try {
        if (Math.abs(vlOrcadoArredondado - this.vlOrcado) > 0.001) {
          this.vlOrcado = vlOrcadoArredondado;
          console.log("vlOrcado atualizado para:", this.vlOrcado);
        }
      } finally {
        setTimeout(() => {
          this.suprimirCalculos = false;
        }, 100);
      }
    },

    calcularVlAstec() {
      if (this.suprimirCalculos) {
        return;
      }

      if (!this.vlOrcado || !this.perAstec) {
        return;
      }
      let perAstecStr = this.perAstec.toString();
      if (perAstecStr.includes("%")) {
        perAstecStr = perAstecStr.replace(" %", "").trim();
      }

      let percentual = parseFloat(perAstecStr.replace(",", "."));

      if (isNaN(percentual)) {
        return;
      }

      if (percentual > 100.0) {
        this.perAstec = "100,00 %";
        percentual = 100.0;
      }

      const novoVlAstec = (percentual / 100.0) * this.vlOrcado;
      const vlAstecArredondado = parseFloat(novoVlAstec.toFixed(2));

      if (Math.abs(vlAstecArredondado - this.vlAstec) > 0.001) {
        this.suprimirCalculos = true;
        this.vlAstec = vlAstecArredondado;
        setTimeout(() => {
          this.suprimirCalculos = false;
        }, 50);
      }
    },

    calcularVlOrcado() {
      if (this.suprimirCalculos) {
        return;
      }

      if (!this.vlAstec || !this.perAstec) {
        return;
      }

      let perAstecStr = this.perAstec.toString();
      if (perAstecStr.includes("%")) {
        perAstecStr = perAstecStr.replace(" %", "").trim();
      }

      let percentual = parseFloat(perAstecStr.replace(",", "."));

      if (isNaN(percentual) || percentual === 0) {
        return;
      }

      if (percentual > 100.0) {
        this.perAstec = "100,00 %";
        percentual = 100.0;
      }

      const novoVlOrcado = this.vlAstec / (percentual / 100);

      if (Math.abs(novoVlOrcado - this.vlOrcado) > 0.001) {
        this.suprimirCalculos = true;
        this.vlOrcado = parseFloat(novoVlOrcado.toFixed(2));
        setTimeout(() => {
          this.suprimirCalculos = false;
        }, 50);
      }
    },

    onVlAstecChange() {
      if (!this.disabledCampos) {
        this.calcularVlOrcadoDebounced();
      }
    },

    async getNomeRazaoUsuario() {
      try {
        this.cdPessoa = this.$store.state.me?.cd_pessoa;
        this.sqUsuario = this.$store.state.me?.sq_usuario;
      } catch {
        this.logoutUser();
      }
    },

    async verificarCooperado() {
      if (this.cooperadoLkp.length > 0) {
        const cooperadoEncontrado = this.cooperadoLkp.find(
          cooperado => cooperado.value === this.cdPessoa
        );

        if (cooperadoEncontrado) {
          this.selecaoCooperado = cooperadoEncontrado;
          this.carregarInstFinanceira();
        } else {
          this.selecaoCooperado = null;
        }
      } else {
        this.selecaoCooperado = null;
      }

      return;
    },

    async carregarClienteRural() {
      if (this.selecaoCooperado) {
        this.clienteRuralLkp = [];
        this.selecaoClienteRural = null;
        this.loadingClienteRural = true;

        try {
          const response = await this.$http.get(
            "/api/astec/getLkpClienteRuralProjetos/" +
              this.selecaoCooperado.value
          );

          this.clienteRuralLkp = response.data.map(cliente => {
            return {
              name: cliente.DISPLAY,
              value: cliente.ID,
              cpfCnpj: cliente.NRCPFCNPJ
            };
          });
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }

        this.loadingClienteRural = false;
        await this.carregarInstFinanceira();
      }
    },

    async carregarInstFinanceira() {
      this.instituicaoFinanceiraLkp = [];
      this.instituicaoAgenciaLkp = [];
      this.selecaoInstituicaoFinanceira = null;
      this.selecaoAgencia = null;
      this.loadingInstFinanceira = true;

      await this.buscarLkpInstituicaoFinanc(this.selecaoCooperado.value);

      this.loadingInstFinanceira = false;
    },

    async carregarAgencia() {
      if (this.selecaoInstituicaoFinanceira) {
        this.selecaoAgencia = null;
        this.loadingAgencia = true;
        this.cdCooperadoSelecionado = this.selecaoCooperado.value;

        try {
          const response = await this.$http.get(
            "/api/astec/getLkpAgencia/" +
              this.cdCooperadoSelecionado +
              "/" +
              this.selecaoInstituicaoFinanceira.value
          );

          this.instituicaoAgenciaLkp = response.data.map(nrAgencia => ({
            name: nrAgencia.DISPLAY,
            value: nrAgencia.ID
          }));
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }

        this.loadingAgencia = false;
      } else {
        this.instituicaoAgenciaLkp = [];
        this.selecaoAgencia = null;
      }

      return;
    },

    async carregarItemAgropecuario() {
      if (this.selecaoTipoProjeto) {
        this.perAstec = this.selecaoTipoProjeto.perAstec;
      }

      if (this.selecaoTipoProjeto && this.selecaoSafra) {
        this.selecaoItemAgropecuario = null;
        this.loadingItemAgropecuario = true;

        try {
          const response = await this.$http.get(
            "/api/astec/getLkpItemAgropecuario/" +
              this.selecaoTipoProjeto.value +
              "/" +
              this.selecaoSafra.epoca
          );

          this.itemAgropecuarioLkp = response.data.map(itemAgropecuario => ({
            name: itemAgropecuario.DISPLAY,
            value: itemAgropecuario.ID
          }));
        } catch (err) {
          this.$tools.alerta(err.response.data.message, "error");
        }

        this.loadingItemAgropecuario = false;
      } else {
        this.selecaoItemAgropecuario = null;
        this.itemAgropecuarioLkp = [];
      }

      return;
    },

    duplicarProjeto() {
      this.loading = true;
      this.sqProjetoVar = null;
      this.cdProjeto = 30;
      this.statusProjeto = "ELABORADO";
      this.numeroProjeto = "";
      this.dataProjeto = "";
      this.selecaoSafra = "";
      this.nrOperacao = "";
      this.vlOrcado = "";
      this.vlAstec = "";
      this.vlLiberado = "";
      this.dataCredito = "";
      this.nOperacao = "";
      this.dataVencBoleto = "";
      this.perAstec = "";
      this.titleHeader = "Duplicando Projeto Astec";
      this.permiteDuplicar = false;

      setTimeout(() => {
        this.loading = false;
        this.disabledCampos = false;
      }, 1000);
    },

    insertProjeto(acao) {
      this.loadingGeral = true;
      this.loadingSalvarNormal = false;
      this.loadingSalvarVoltar = false;
      this.loadingSalvarExportar = false;
      this.loadingSalvarContinuar = false;

      const mapaAcoes = {
        salvar: "loadingSalvarNormal",
        voltar: "loadingSalvarVoltar",
        exportar: "loadingSalvarExportar",
        continuar: "loadingSalvarContinuar"
      };

      this[mapaAcoes[acao]] = true;

      this.submit = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.loadingGeral = false;
        this[mapaAcoes[acao]] = false;
        return;
      }

      const obj = this.montarObjeto();

      if (this.importacao) {
        const sqAstecIntegracaoItem = this.$store.state.projetoAstec
          .SQ_ASTEC_INTEGRACAO_ITEM;
        const sqAstecIntegracaoLote = this.$store.state.projetoAstec
          .SQ_ASTEC_INTEGRACAO_LOTE;

        this.$http
          .put(
            `/api/astec/projetos/importarProjetos/projetosLote/${sqAstecIntegracaoItem}/${sqAstecIntegracaoLote}`,
            { ...obj, acao }
          )
          .then(response => {
            Swal.fire({
              icon: "success",
              title: "Sucesso",
              text: response.data.message
            });

            localStorage.removeItem("exibirCamposImportacao");
            this.$router.push("/astec/projetos/lotesImportacao/projetosLote");
          })
          .catch(error => {
            const msg =
              error.response?.data?.message || "Erro ao salvar projeto";
            this.$tools.alerta(msg, "error");
          })
          .finally(() => {
            this.loadingGeral = false;
            this[mapaAcoes[acao]] = false;
          });

        return;
      }

      this.$http
        .post("/api/astec/insertProjetos", obj)
        .then(response => {
          Swal.fire({
            icon: "success",
            title: "Sucesso",
            text: `Projeto ${response.data[0].ID} salvo com sucesso!`
          });

          if (acao === "voltar") {
            this.$router.push("/astec/projetos");
          } else if (acao === "continuar") {
            this.limparFormCadastro();
          }
        })
        .catch(err => {
          const msg = err.response?.data?.message || "Erro ao salvar projeto";
          this.$tools.alerta(msg, "error");
        })
        .finally(() => {
          this.loadingGeral = false;
          this[mapaAcoes[acao]] = false;
        });
    },

    montarObjeto() {
      const dados = {
        sqUsuario: this.sqUsuario,
        sqProjetoVar: this.sqProjetoVar,
        cdProjeto: this.cdProjeto,
        cdCooperado: this.selecaoCooperado ? this.selecaoCooperado.value : null,
        sqCliente: this.selecaoClienteRural
          ? this.selecaoClienteRural.value
          : null,
        nrPlano: this.numeroProjeto ? this.numeroProjeto : null,
        dtProjeto: this.dataProjeto ? this.dataProjeto : null,
        sqLinhaCredito: this.selecaoLinhaCredito
          ? this.selecaoLinhaCredito.value
          : null,
        sqTpProjeto: this.selecaoTipoProjeto
          ? this.selecaoTipoProjeto.value
          : null,
        sqModalidadeSeguro: this.selecaoModalidadeSeguro
          ? this.selecaoModalidadeSeguro.value
          : null,
        cdItemAgropecuario: this.selecaoItemAgropecuario
          ? parseInt(this.selecaoItemAgropecuario.value)
          : null,
        sqRegiao: this.selecaoMunicipio ? this.selecaoMunicipio.value : null,
        cidade: this.selecaoMunicipio
          ? this.selecaoMunicipio.name.split(" - ")[0]
          : null,
        estado: this.selecaoMunicipio
          ? this.selecaoMunicipio.name.split(" - ")[1]
          : null,
        cdSafra: this.selecaoSafra ? this.selecaoSafra.name : null,
        qtArea: this.areaHa ? this.areaHa : null,
        cdOperacaoCred: this.nOperacao ? this.nOperacao : null,
        vlOrcado: this.vlOrcado ? this.vlOrcado : null,
        vlAstec: this.vlAstec ? this.vlAstec : 0,
        dtCredito: this.dataCredito ? this.dataCredito : null,
        cdBanco: this.selecaoInstituicaoFinanceira
          ? this.selecaoInstituicaoFinanceira.value
          : null,
        nrAgencia: this.selecaoAgencia ? this.selecaoAgencia.value : null,
        dtVctoFinanc: this.dataVencBoleto ? this.dataVencBoleto : "",
        cdInstituicaoFinanceira: this.selecaoInstituicaoFinanceira
          ? this.selecaoInstituicaoFinanceira.value
          : null
      };

      return dados;
    },

    async voltar() {
      const dadosAoVoltar = await this.montarObjeto();

      if (
        (this.statusProjeto === "ELABORADO" || this.importacao) &&
        JSON.stringify(dadosAoVoltar) !== JSON.stringify(this.dadosAoCarregar)
      ) {
        Swal.fire({
          icon: "warning",
          title: "ATENÇÃO",
          text:
            "Caso confirme, os dados cadastrados serão perdidos. Deseja sair sem salvar?",
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não"
        }).then(result => {
          if (result.isConfirmed) {
            localStorage.removeItem("exibirCamposImportacao");

            this.importacao
              ? this.$router.push(
                  "/astec/projetos/lotesImportacao/projetosLote"
                )
              : this.$router.push("/astec/projetos");
          }
        });
      } else {
        localStorage.removeItem("exibirCamposImportacao");

        this.importacao
          ? this.$router.push("/astec/projetos/lotesImportacao/projetosLote")
          : this.$router.push("/astec/projetos");
      }
    },

    formatCpfCnpj(option) {
      return option.cpfCnpj;
    },

    normalizeCpfCnpj(value) {
      if (!value) return "";
      return value.replace(/\D/g, "");
    },

    updateSearch(query) {
      this.searchQuery = query;
    },

    limparFormCadastro() {
      this.sqProjetoVar = "";
      this.cdProjeto = 30;
      this.selecaoClienteRural = "";
      this.numeroProjeto = "";
      this.dataProjeto = "";
      this.selecaoLinhaCredito = "";
      this.selecaoTipoProjeto = "";
      this.selecaoModalidadeSeguro = "";
      this.selecaoItemAgropecuario = "";
      this.selecaoMunicipio = "";
      this.selecaoSafra = "";
      this.areaHa = "";
      this.nOperacao = "";
      this.vlOrcado = 0;
      this.vlAstec = 0;
      this.dataCredito = "";
      this.selecaoInstituicaoFinanceira = "";
      this.selecaoAgencia = "";
      this.dataVencBoleto = "";
      this.selecaoInstituicaoFinanceira = "";
      this.submit = false;
    },

    gerarBoleto() {
      this.loadingBoleto = true;
      this.loadingGeral = true;

      this.$http
        .get(
          `/api/astec/projetos/gerarBoleto/${this.sqProjetoVar}/${this.selecaoCooperado.value}`,
          {
            responseType: "blob"
          }
        )
        .then(response => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          this.urlPagamento = URL.createObjectURL(blob);
          this.abreModal = true;
        })
        .catch(async error => {
          if (error.response && error.response.data instanceof Blob) {
            const text = await error.response.data.text();
            const message = JSON.parse(text);

            this.$tools.alerta(
              message.message || "Erro ao gerar boleto do projeto",
              "error"
            );
          } else {
            this.$tools.alerta("Erro ao gerar boleto do projeto", "error");
          }
        })
        .finally(() => {
          this.loadingBoleto = false;
          this.loadingGeral = false;
        });
    },

    gerarPix() {
      this.loadingPix = true;
      this.loadingGeral = true;

      this.$http
        .post(`/api/astec/projetos/gerarPix/${this.sqProjetoVar}`, {
          valor: this.vlAstec
        })
        .then(response => {
          if (response.status === 200) {
            this.qrCodeImage = response.data.qrCode;
            this.textAreaData = response.data.copiaCola || "";

            this.dadosPixDoProjeto = mapearDadosFormularioProjeto(this);

            this.mostraQRCode = true;
          }
        })
        .catch(error => {
          if (error.response.data.erro == true) {
            this.$tools.alerta(error.response.data.mensagem, "error");
          } else {
            this.$tools.alerta("Erro ao gerar pix do projeto", "error");
          }
        })
        .finally(() => {
          this.loadingPix = false;
          this.loadingGeral = false;
        });
    },

    openModalMovimentacao() {
      this.showModalMovimentacao = true;
      this.buscaMovimentacoes();
    },

    async buscaMovimentacoes() {
      const data = await MovimentacaoService.getByProjeto(this.sqProjetoVar);
      if (data) {
        this.retornoMovimentacao = data;
      }
    },

    statusTipoProjeto(value) {
      const status = ["LIBERADO", "LIQUIDADO", "BAIXA PARCIAL"];
      return status.includes(value);
    }
  }
};
</script>

<style lang="scss">
.is-valid .v-money {
  border-color: #34c38f !important;
}
.is-invalid .v-money {
  border-color: #f46a6a !important;
}

.opacity-date {
  opacity: 0.6;
  pointer-events: none;
}
</style>
